import { render } from "./InfoIcon.vue?vue&type=template&id=1f5fddb3&scoped=true&ts=true"
import script from "./InfoIcon.vue?vue&type=script&lang=ts"
export * from "./InfoIcon.vue?vue&type=script&lang=ts"

import "./InfoIcon.vue?vue&type=style&index=0&id=1f5fddb3&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5fddb3"]])

export default __exports__